import { jObjectLittleSchema } from './objectBase';
import { z } from 'zod';

export const uploadConfigSchema = z.object({
    attrName: z.string(),
    token: z.string(),
    file: z.instanceof(File).nullable().optional(),
    url: z.string().optional(),
});
export type UploadConfig = z.infer<typeof uploadConfigSchema>;

export const imageSizeSchema = z.object({
    width: z.number(),
    height: z.number(),
});
export type ImageSize = z.infer<typeof imageSizeSchema>;

export const imageFormValueSchema = z.object({
    type: z.string(),
    id: z.number(),
    timestamp: z.string(),
    imagesize: z.optional(imageSizeSchema),
});
export type ImageFormValue = z.infer<typeof imageFormValueSchema>;

export const fileCropConfigSchema = z.object({
    x: z.number(),
    y: z.number(),
    w: z.number(),
    h: z.number(),
    rotation: z.number(),
    killSize: z.boolean().optional(),
});
export type FileCropConfig = z.infer<typeof fileCropConfigSchema>;

export const jFileLittleSchema = jObjectLittleSchema.extend({
    dateCreation: z.string(),
    dateModified: z.string().nullable(),
    mimetype: z.string(),
    path: z.string().optional(),
    size: z.number(),
});
export type jFileLittle = z.infer<typeof jFileLittleSchema>;
export const validateIsFormatFileLittle = (object: object): jFileLittle => {
    return jFileLittleSchema.parse(object);
};

export const jFileLittleCropSchema = jFileLittleSchema.extend({
    _extend: z.object({
        crop: fileCropConfigSchema,
    }),
});
export type jFileLittleCrop = z.infer<typeof jFileLittleCropSchema>;

export const jFileRenditionSchema = z.object({
    name: z.string(),
    filename: z.string(),
    dateModified: z.string(),
    mimetype: z.string(),
});
export type jFileRendition = z.infer<typeof jFileRenditionSchema>;

export const userDownloadSchema = z.object({
    idUser: z.string(),
    dateDownload: z.string(),
    Pseudo: z.string(),
    type: z.string(),
});
export type UserDownload = z.infer<typeof userDownloadSchema>;

const fileCopyParamsSchema = z.object({
    id: z.number(),
    token: z.string().optional(),
    attrName: z.string(),
});
export type FileCopyParams = z.infer<typeof fileCopyParamsSchema>;
